import { GetServiceAgreementListResponse, ServiceAgreementListCategory } from 'pco-product-service-internal-consumer';
import { serviceAgreementApi } from 'api';

export const getServiceAgreementList = async (params: {
  partnerUid?: string;
  businessRelationUid?: string;
  category?: ServiceAgreementListCategory;
}): Promise<GetServiceAgreementListResponse> => {
  return await serviceAgreementApi.getServiceAgreements({
    partnerUid: params.partnerUid,
    businessRelationUid: params.businessRelationUid,
    category: params.category,
  });
};
